import axios from 'axios';
import {
  AUTHENTICATE_LOADING,
  AUTHENTICATE_SUCCESS,
  SESSION_FINISHED,
  AUTHENTICATE_FAIL,
  VERIFY_FAIL
} from './reducer';

export const authenticateLoading = isLoading => (dispatch) => {
  dispatch({
    type: AUTHENTICATE_LOADING,
    payload: isLoading
  });
};

export const authenticateSuccess = () => (dispatch) => {
  dispatch({
    type: AUTHENTICATE_SUCCESS,
    payload: true
  });
};

export const endAuthentication = () => (dispatch) => {
  dispatch({
    type: SESSION_FINISHED,
    payload: true
  });
};

export const authenticateFail = error => (dispatch) => {
  dispatch({
    type: VERIFY_FAIL,
    payload: error
  });
};

/**
 * Check if the user is already authenticated
 */
export const checkAuthentication = () => (dispatch) => {
  dispatch({ type: AUTHENTICATE_LOADING, payload: true });

  fetch(`${process.env.REACT_APP_API_URL}/verifyToken`, { credentials: 'include' })
    .then((response) => {
      if (response.status === 200) {
        dispatch({ type: AUTHENTICATE_SUCCESS });
      } else {
        dispatch({ type: VERIFY_FAIL, payload: response.statusText });
      }
    })
    .catch((err) => {
      console.error(err);
      dispatch({ type: VERIFY_FAIL, payload: err });
    })
    .then(() => dispatch({ type: AUTHENTICATE_LOADING, payload: false }));
};

/**
 * Set the current hour
 * @param {{ email: string, password: string }}
 */
export const authenticateProfile = () => (dispatch) => {
  dispatch({ type: AUTHENTICATE_LOADING, payload: true });
  return axios({
    url: `${process.env.REACT_APP_API_URL}/login`,
    method: 'POST',
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    },
    data: JSON.stringify({
      email: process.env.REACT_APP_EMAIL,
      password: process.env.REACT_APP_PASSWORD
    })
  })
    .then((response) => {
      if (response.status >= 200) {
        dispatch({ type: AUTHENTICATE_SUCCESS });
      } else {
        console.error(response.statusText);
        dispatch({ type: AUTHENTICATE_FAIL, payload: response.statusText });
      }
    })
    .catch((err) => {
      console.error(err);
      dispatch({ type: AUTHENTICATE_FAIL, payload: err });
    })
    .then(() => dispatch({ type: AUTHENTICATE_LOADING, payload: false }));
};



// WEBPACK FOOTER //
// ./src/components/login-form/actions.js